<template>
  <v-stepper v-model="step" elevation="0">    
    <v-stepper-header elevation="0" style="box-shadow: none;">
      <v-stepper-step :complete="step > 1" step="1" color="success">
        Empresa
      </v-stepper-step>

      <v-stepper-step :complete="step > 2" step="2" color="success">
        Pagamento <span v-if="order">R$ {{ order.type_solicitation.value}}</span>
        <small>Forma de pagamento</small>
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form ref="newOrderForm" lazy-validation @submit.prevent="onSubmit">
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" :xs="12">              
              <v-text-field
                :value="`${user.name} - ${user.cnpj}`"
                label="Empresa"
                required
                :disabled="true"
                outlined
                dense    
                multiple
                class="mt-1"
              ></v-text-field>
            </v-col>
          </v-row>    
          <v-btn depressed color="success" type="submit">
            Continuar
          </v-btn>    
        </v-form>        
      </v-stepper-content>

      <v-stepper-content step="2">        
        <OrderPaymentForm v-if="order" :order="order" />
      </v-stepper-content>
    </v-stepper-items>   
  </v-stepper>
</template>

<script>
import GlobalStore from "@/store/modules/global";

import OrderPaymentForm from './OrderPaymentForm.vue';
import OrderService from '@/services/order.service';
import PaymentService from '@/services/pagamento.service';

export default {
  name: "OrderCheckoutCompanyRegistrationRenewal",
  
  components: {    
    OrderPaymentForm
  },

  data: () => ({
    step: 1,

    order: null,
  }),

  computed: {
    user: () => GlobalStore.user || {}
  },

  methods: {
    onSubmit() {
      if (!this.$refs.newOrderForm.validate()) return;      

      OrderService
        .createCompanyRegistrationRenewal()
        .subscribe(({data}) => {
          this.fetchOrder(data.id);          
      });
    },

    onEventOrderCreated() {
      this.step = 2;
    },

    fetchOrder(order_id) {
      if (!order_id) return;

      OrderService
        .show(order_id)
        .subscribe({ 
          next: (data) => { 
            this.order = data;
            this.onEventOrderCreated();
          } 
        });
    }
  },
};
</script>